import api, { isHTTPError } from '../api'
import useDataLoader from '../dataLoader'

const useMergeAccount = () => {
  const mergeAccount = async (requestId: string, email: string, password: string | null) => {
    try {
        return await api.mergeAccounts(requestId, email, password)
      } catch (error) {
        if (isHTTPError(error) && error.response && error.response.status === 404) {
          const errorMessage = 'Something went wrong while merging accounts'
          return errorMessage
          // return error.response.data.detail.type
        } else if (isHTTPError(error) && error.response && 'detail' in error.response.data) {
            return error.response.data.detail.type
      }
    }
  }

  return useDataLoader(mergeAccount, [], [])
}

export default useMergeAccount
